import { CARD_PAGE_OFFSET } from "../configs/app.configs";
import { supabase_stories } from "./supabase"




export async function GetStories(params: { search?: string, page?: number, order?: 'asc' | 'desc' }) {
    // Calculate row bounds

    let pages = 0
    const from = ((params.page ?? 1) - 1) * CARD_PAGE_OFFSET;
    const to = from + CARD_PAGE_OFFSET - 1;

    const { data, error, count } = await supabase_stories
        .schema('stories')
        .from('Stories')
        .select('*', { count: 'exact' })
        .ilike('title', `%${params.search ?? ''}%`)
        .order('id', { ascending: params.order == undefined || params.order == 'asc' }) // Good practice for stable pagination
        .range(from, to);
    
         pages = Math.ceil((count || 0)/CARD_PAGE_OFFSET)



    console.log(supabase_stories)
    if (error) {
        console.error(error)
        return
    }

    return { data, error,count , pages }
}
